const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M219.4,0H66.3c-1.3,0-2.3,1-2.3,2.3v16c0,1.3,1,2.3,2.3,2.3h141.7v196.6c0,1.3,1,2.3,2.3,2.3h16c1.3,0,2.3-1,2.3-2.3V9.1c0-5.1-4.1-9.1-9.1-9.1Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.9,36.6H36.6c-5.1,0-9.1,4.1-9.1,9.1v151.6c0,2.4,1,4.7,2.7,6.5l49.5,49.5c.6.6,1.3,1.1,2.1,1.6v.5h1.2c1,.4,2.1.6,3.1.6h96.8c5.1,0,9.1-4.1,9.1-9.1V45.7c0-5.1-4.1-9.1-9.1-9.1ZM81.7,226.3l-24.6-24.6h24.6v24.6ZM171.4,235.4h-71.4v-40.6c0-6.3-5.1-11.4-11.4-11.4h-40.6V57.1h123.4v178.3Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.33441857b4e9974cfc2181244cdc78be.svg";
export { ForwardRef as ReactComponent };